var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ExportMenu } from '@web/components/layout/ExportMenu/ExportMenu';
import { ChartSeriesVisibility } from '@web/components/layout/RechartsItems/ChartSeriesVisibility';
import CustomTooltip from '@web/components/layout/RechartsItems/CustomTooltip';
import { createEdgePositionedBarTooltipContent } from '@web/components/layout/RechartsItems/EdgePositionedBarTooltip';
import LegendItem from '@web/components/layout/RechartsItems/LegendItem';
import { renderStackedBarCells } from '@web/components/layout/RechartsItems/StackedBarCells';
import { Widget } from '@web/components/layout/Widget';
import { WidgetChartPlotArea } from '@web/components/layout/WidgetChartPlotArea/WidgetChartPlotArea';
import { WidgetTitle } from '@web/components/layout/WidgetTitle/WidgetTitle';
import { TablesDiffColorsConfig } from '@web/config';
import { isAiButtonDisabled } from '@web/utility';
import { ComparisonPeriod, navigateToEventsLogFromPeriodChartBarClick } from '@web/utility/chartNavigation';
import { formatChartDayPeriodAxisLabel, getPeriodBarChartLayoutProps, isBarChartRowsEmpty } from '@web/utility/charts';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { AnalyticPeriodsEnum, ApplicationEnum } from '@workalizer/shared';
import { InitiatedCommunicationByChannel, ReceivedCommunicationByChannel } from '@workalizer/shared/enums';
import { InsightTypeEnum } from '@workalizer/shared/enums';
import { diffComparisonType } from '@workalizer/shared/types';
import { getInterval, getPercentageDiff, groupByPeriod } from '@workalizer/shared/utils';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
var COMMUNICATION_CONFIG = {
    emails: {
        sent: {
            color: 'bg-sky-500',
            chartColor: '#61ACDB',
            translationKey: 'app.performanceReview.employeePerformanceReview.communicationSection.tablesData.sentEmails'
        },
        received: {
            color: 'bg-emerald-500',
            chartColor: '#43B881',
            translationKey: 'app.performanceReview.employeePerformanceReview.communicationSection.tablesData.receivedEmails'
        }
    },
    chats: {
        sent: {
            color: 'bg-sky-600',
            chartColor: '#3F89B8',
            translationKey: 'app.performanceReview.employeePerformanceReview.communicationSection.tablesData.sentChats'
        },
        received: {
            color: 'bg-emerald-600',
            chartColor: '#398F67',
            translationKey: 'app.performanceReview.employeePerformanceReview.communicationSection.tablesData.receivedChats'
        }
    }
};
var SENT_STACK_DATA_KEYS = ['sentChats', 'sentEmails'];
var RECEIVED_STACK_DATA_KEYS = ['receivedChats', 'receivedEmails'];
var SENT_VS_RECEIVED_SERIES_KEYS = [
    'sentEmails',
    'sentChats',
    'receivedEmails',
    'receivedChats'
];
var getSentVsReceivedSeriesKey = function (direction, channel) { return "".concat(direction).concat(channel.charAt(0).toUpperCase() + channel.slice(1)); };
export var SentVSReceivedRatio = function (_a) {
    var data = _a.data, refetch = _a.refetch, dateFrom = _a.dateFrom, dateTo = _a.dateTo, userId = _a.userId, orgUnitId = _a.orgUnitId;
    var t = useTranslation().t;
    var navigateTo = useNavigateTo();
    var groupByInterval = useMemo(function () {
        var interval = getInterval(dateFrom, dateTo);
        return interval === AnalyticPeriodsEnum.HOUR
            ? AnalyticPeriodsEnum.DAY
            : interval;
    }, [dateFrom, dateTo]);
    var transformedData = useMemo(function () {
        var fromDate = new Date(dateFrom);
        var toDate = new Date(dateTo);
        var emailsSent = data.Initiated.find(function (item) { return item.channel === InitiatedCommunicationByChannel.EMAILS_SENT; });
        var emailsReceived = data.Received.find(function (item) { return item.channel === ReceivedCommunicationByChannel.EMAILS_RECEIVED; });
        var chatsSent = data.Initiated.find(function (item) {
            return item.channel === InitiatedCommunicationByChannel.CHATS_MESSAGES_POSTED;
        });
        var chatsReceived = data.Received.find(function (item) {
            return item.channel === ReceivedCommunicationByChannel.CHATS_MESSAGES_RECEIVED;
        });
        var emailsSentMapped = emailsSent.daily.map(function (day) { return ({
            date: day.date,
            items: [{ count: day.count }]
        }); });
        var emailsReceivedMapped = emailsReceived.daily.map(function (day) { return ({
            date: day.date,
            items: [{ count: day.count }]
        }); });
        var chatsSentMapped = chatsSent.daily.map(function (day) { return ({
            date: day.date,
            items: [{ count: day.count }]
        }); });
        var chatsReceivedMapped = chatsReceived.daily.map(function (day) { return ({
            date: day.date,
            items: [{ count: day.count }]
        }); });
        var emailsSentGrouped = groupByPeriod(emailsSentMapped, fromDate, toDate, groupByInterval);
        var emailsReceivedGrouped = groupByPeriod(emailsReceivedMapped, fromDate, toDate, groupByInterval);
        var chatsSentGrouped = groupByPeriod(chatsSentMapped, fromDate, toDate, groupByInterval);
        var chatsReceivedGrouped = groupByPeriod(chatsReceivedMapped, fromDate, toDate, groupByInterval);
        var sumItems = function (items) {
            return items.reduce(function (sum, item) { return sum + item.count; }, 0);
        };
        var toTeamAverageDiff = function (teamAvg, value) {
            return userId
                ? getPercentageDiff(teamAvg, value, {
                    comparisonType: diffComparisonType.teamAverage
                })
                : undefined;
        };
        return [
            {
                type: 'emails',
                sent: {
                    value: emailsSent.total,
                    prevValue: emailsSent.prevTotal,
                    diffValue: emailsSent.userPrevPeriodDiff,
                    teamAverage: toTeamAverageDiff(emailsSent.avg, emailsSent.total)
                },
                received: {
                    value: emailsReceived.count,
                    prevValue: emailsReceived.prevTotal,
                    diffValue: emailsReceived.userPrevPeriodDiff,
                    teamAverage: toTeamAverageDiff(emailsReceived.avg, emailsReceived.count)
                },
                groupedByPeriod: emailsSentGrouped.map(function (period, index) {
                    var _a;
                    return ({
                        period: period.date,
                        sent: sumItems(period.items),
                        received: sumItems(((_a = emailsReceivedGrouped[index]) === null || _a === void 0 ? void 0 : _a.items) || [])
                    });
                })
            },
            {
                type: 'chats',
                sent: {
                    value: chatsSent.total,
                    prevValue: chatsSent.prevTotal,
                    diffValue: chatsSent.userPrevPeriodDiff,
                    teamAverage: toTeamAverageDiff(chatsSent.avg, chatsSent.total)
                },
                received: {
                    value: chatsReceived.count,
                    prevValue: chatsReceived.prevTotal,
                    diffValue: chatsReceived.userPrevPeriodDiff,
                    teamAverage: toTeamAverageDiff(chatsReceived.avg, chatsReceived.count)
                },
                groupedByPeriod: chatsSentGrouped.map(function (period, index) {
                    var _a;
                    return ({
                        period: period.date,
                        sent: sumItems(period.items),
                        received: sumItems(((_a = chatsReceivedGrouped[index]) === null || _a === void 0 ? void 0 : _a.items) || [])
                    });
                })
            }
        ];
    }, [data, dateFrom, dateTo, groupByInterval, userId]);
    var chartDataForExport = transformedData[0].groupedByPeriod.map(function (periodRow, index) {
        var emailsData = transformedData[0].groupedByPeriod[index];
        var chatsData = transformedData[1].groupedByPeriod[index];
        return {
            period: periodRow.period,
            receivedEmails: emailsData.received,
            receivedChats: chatsData.received,
            sentEmails: emailsData.sent,
            sentChats: chatsData.sent
        };
    });
    var chartData = chartDataForExport;
    var handleBarClick = function (dataKey, barData, fallbackIndex) {
        navigateToEventsLogFromPeriodChartBarClick({
            chartData: chartData,
            barData: barData,
            fallbackIndex: fallbackIndex,
            stack: ComparisonPeriod.Current,
            app: dataKey.includes('Emails')
                ? ApplicationEnum.GMAIL
                : ApplicationEnum.CHAT,
            navigateTo: navigateTo,
            dateFrom: dateFrom,
            dateTo: dateTo,
            userId: userId,
            orgUnitId: orgUnitId
        });
    };
    var _b = getPeriodBarChartLayoutProps({
        barGroupCount: chartData.length,
        barsPerGroup: 2
    }), barGap = _b.barGap, barSize = _b.barSize, periodXAxis = _b.periodXAxis, periodBarChartMargin = _b.periodBarChartMargin;
    var chartPlotEmpty = isBarChartRowsEmpty(chartData);
    var legendItems = [
        {
            type: 'sent',
            items: [
                {
                    key: 'emails',
                    currentValue: transformedData[0].sent.value,
                    prevValue: transformedData[0].sent.prevValue,
                    diffValue: transformedData[0].sent.diffValue,
                    teamAverage: transformedData[0].sent.teamAverage
                },
                {
                    key: 'chats',
                    currentValue: transformedData[1].sent.value,
                    prevValue: transformedData[1].sent.prevValue,
                    diffValue: transformedData[1].sent.diffValue,
                    teamAverage: transformedData[1].sent.teamAverage
                }
            ]
        },
        {
            type: 'received',
            items: [
                {
                    key: 'emails',
                    currentValue: transformedData[0].received.value,
                    prevValue: transformedData[0].received.prevValue,
                    diffValue: transformedData[0].received.diffValue,
                    teamAverage: transformedData[0].received.teamAverage
                },
                {
                    key: 'chats',
                    currentValue: transformedData[1].received.value,
                    prevValue: transformedData[1].received.prevValue,
                    diffValue: transformedData[1].received.diffValue,
                    teamAverage: transformedData[1].received.teamAverage
                }
            ]
        }
    ];
    var renderSentVsReceivedTooltip = createEdgePositionedBarTooltipContent(_jsx(CustomTooltip, { seriesOrder: [
            'sentChats',
            'sentEmails',
            'receivedChats',
            'receivedEmails'
        ], separatorAfterDataKeys: ['sentEmails'], formatValue: function (value) { return String(value); } }), chartData.length);
    return (_jsxs("div", __assign({ className: "w-full" }, { children: [_jsx(WidgetTitle, { title: t('app.performanceReview.employeePerformanceReview.communicationSection.sentVsReceivedRatio'), description: t('widgetTitleDescriptions.communication.sentVsReceivedEmailsAndChatsRatio'), insightType: InsightTypeEnum.sentVsReceivedEmailsAndChatsRatio, insightsData: data, refetch: refetch, csvExport: _jsx(ExportMenu, { fileName: t('app.performanceReview.employeePerformanceReview.communicationSection.sentVsReceivedRatio'), onExportHandler: function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, chartDataForExport.map(function (row) {
                                    var _a;
                                    return (_a = {},
                                        _a[t('filters.period')] = row.period,
                                        _a[t('app.performanceReview.employeePerformanceReview.communicationSection.tablesData.sentEmails')] = row.sentEmails,
                                        _a[t('app.performanceReview.employeePerformanceReview.communicationSection.tablesData.sentChats')] = row.sentChats,
                                        _a[t('app.performanceReview.employeePerformanceReview.communicationSection.tablesData.receivedEmails')] = row.receivedEmails,
                                        _a[t('app.performanceReview.employeePerformanceReview.communicationSection.tablesData.receivedChats')] = row.receivedChats,
                                        _a);
                                })];
                        });
                    }); }, disabled: isAiButtonDisabled(data) }) }), _jsx(ChartSeriesVisibility, __assign({ seriesKeys: SENT_VS_RECEIVED_SERIES_KEYS }, { children: function (_a) {
                    var toggleSeries = _a.toggleSeries, isSeriesVisible = _a.isSeriesVisible;
                    return (_jsxs(Widget, __assign({ cardClassName: "shadow overflow-x-auto lg:overflow-visible border-b border-gray-200 sm:rounded-lg p-6", className: "lock w-full max-w-full py-2 align-middle sm:px-6 lg:pl-2 lg:pr-2" }, { children: [_jsx("div", __assign({ className: "flex gap-8 lg:gap-8 mb-6 p-4 ml-2 rounded-lg justify-start flex-wrap" }, { children: legendItems.map(function (_a) {
                                    var type = _a.type, items = _a.items;
                                    return (_jsx("div", __assign({ className: "flex flex-col gap-2 lg:gap-4" }, { children: items.map(function (_a) {
                                            var key = _a.key, currentValue = _a.currentValue, diffValue = _a.diffValue, teamAverage = _a.teamAverage;
                                            var seriesKey = getSentVsReceivedSeriesKey(type, key);
                                            return (_jsx(LegendItem, { color: COMMUNICATION_CONFIG[key][type].color, label: t(COMMUNICATION_CONFIG[key][type].translationKey), currentValue: currentValue, diffValue: diffValue, teamAverage: teamAverage, arrowColor: TablesDiffColorsConfig.GREEN, currentValueClassName: "text-sm font-semibold", onClick: function () { return toggleSeries(seriesKey); }, isHidden: !isSeriesVisible(seriesKey) }, "".concat(type, "-").concat(key)));
                                        }) }), type));
                                }) })), _jsx(WidgetChartPlotArea, __assign({ isEmpty: chartPlotEmpty }, { children: _jsx(ResponsiveContainer, __assign({ width: "100%", height: 400 }, { children: _jsxs(BarChart, __assign({ data: chartData, barGap: barGap, barSize: barSize, margin: periodBarChartMargin }, { children: [_jsx(CartesianGrid, { strokeDasharray: "3 3", stroke: "#f3f4f6" }), _jsx(XAxis, __assign({ dataKey: "period", axisLine: false, tickLine: false }, periodXAxis, { tickFormatter: function (value) {
                                                    return formatChartDayPeriodAxisLabel(value, groupByInterval, {
                                                        dateFrom: dateFrom,
                                                        dateTo: dateTo
                                                    });
                                                } })), _jsx(YAxis, { axisLine: false, tickLine: false, tick: { fontSize: 12, fill: '#6b7280' } }), _jsx(Tooltip, { allowEscapeViewBox: { x: true, y: true }, content: renderSentVsReceivedTooltip }), _jsx(Bar, __assign({ dataKey: "sentChats", fill: COMMUNICATION_CONFIG.chats.sent.chartColor, stackId: "sent", hide: !isSeriesVisible('sentChats'), onClick: function (barData, index) {
                                                    return handleBarClick('sentChats', barData, index);
                                                }, style: { cursor: 'pointer' } }, { children: renderStackedBarCells({
                                                    chartData: chartData,
                                                    stackDataKeys: SENT_STACK_DATA_KEYS,
                                                    segmentIndex: 0,
                                                    keyPrefix: 'sent-chats'
                                                }) })), _jsx(Bar, __assign({ dataKey: "sentEmails", fill: COMMUNICATION_CONFIG.emails.sent.chartColor, stackId: "sent", hide: !isSeriesVisible('sentEmails'), onClick: function (barData, index) {
                                                    return handleBarClick('sentEmails', barData, index);
                                                }, style: { cursor: 'pointer' } }, { children: renderStackedBarCells({
                                                    chartData: chartData,
                                                    stackDataKeys: SENT_STACK_DATA_KEYS,
                                                    segmentIndex: 1,
                                                    keyPrefix: 'sent-email'
                                                }) })), _jsx(Bar, __assign({ dataKey: "receivedChats", fill: COMMUNICATION_CONFIG.chats.received.chartColor, stackId: "received", hide: !isSeriesVisible('receivedChats'), onClick: function (barData, index) {
                                                    return handleBarClick('receivedChats', barData, index);
                                                }, style: { cursor: 'pointer' } }, { children: renderStackedBarCells({
                                                    chartData: chartData,
                                                    stackDataKeys: RECEIVED_STACK_DATA_KEYS,
                                                    segmentIndex: 0,
                                                    keyPrefix: 'received-chats'
                                                }) })), _jsx(Bar, __assign({ dataKey: "receivedEmails", fill: COMMUNICATION_CONFIG.emails.received.chartColor, stackId: "received", hide: !isSeriesVisible('receivedEmails'), onClick: function (barData, index) {
                                                    return handleBarClick('receivedEmails', barData, index);
                                                }, style: { cursor: 'pointer' } }, { children: renderStackedBarCells({
                                                    chartData: chartData,
                                                    stackDataKeys: RECEIVED_STACK_DATA_KEYS,
                                                    segmentIndex: 1,
                                                    keyPrefix: 'received-email'
                                                }) }))] })) })) }))] })));
                } }))] })));
};
